<template>
  <div class="ma-8">
    <v-card class="mb-8 transparent d-flex justify-space-between" elevation="0">
      <v-btn large class="myYellow2" to="/">
        <v-icon left>mdi-chevron-left</v-icon> Back
      </v-btn>
    </v-card>
    <v-data-table
      v-if="getListHistory.length"
      :headers="historyHeaders"
      :items="getListHistory"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="bill"
      show-expand
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Order History</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-switch
            v-model="singleExpand"
            label="Single expand"
            class="mt-2"
          ></v-switch>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <!-- <td :colspan="headers.length">{{ renderExpand(item) }}</td> -->
        <td class="ma-1 pa-1" :colspan="headers.length">
          <v-card
            class="d-flex justify-center align-center flex-column ma-4 pa-4"
          >
            <v-card
              class="d-flex myGreen white--text font-weight-bold"
              elevation="0"
              width="600"
              tile
            >
              <v-col class="text-center">Menu</v-col>
              <v-col class="text-center">Quantity</v-col>
              <v-col class="text-center">Price</v-col>
            </v-card>
            <v-card
              class="d-flex"
              color="#f0f0f0"
              v-for="list in item.checkout_details"
              :key="list.id"
              elevation="0"
              width="600"
              tile
            >
              <v-col>{{ list.menu }}</v-col>
              <v-col class="text-center">{{ list.quantity }}</v-col>
              <v-col class="text-center">{{ parseRupiah(list.price) }}</v-col>
            </v-card>
          </v-card>
        </td>
      </template>
    </v-data-table>
    <v-card v-else class="pa-8 d-flex justify-center"
      ><h2>TIDAK ADA CATATAN</h2></v-card
    >
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      expanded: [],
      singleExpand: false,
      historyHeaders: [
        {
          text: "Name",
          class: "text-h6 white--text primary",
          align: "start",
          sortable: false,
          value: "customer_name",
        },
        { text: "Date", value: "date", class: "text-h6 white--text primary" },
        {
          text: "Time",
          value: "date_order",
          class: "text-h6 white--text primary",
        },
        {
          text: "Table",
          value: "table_name",
          class: "text-h6 white--text primary",
        },
        {
          text: "Invoice",
          value: "bill",
          class: "text-h6 white--text primary",
        },
        {
          text: "Payment",
          value: "payment_type",
          class: "text-h6 white--text primary",
        },
        {
          text: "Cashier",
          value: "approved_by",
          class: "text-h6 white--text primary",
        },
        { text: "", value: "data-table-expand", class: "primary" },
      ],
      historyDetail: [],
    };
  },

  computed: {
    ...mapGetters(["getListHistory"]),
  },

  methods: {
    ...mapActions(["GET_LIST_HISTORY"]),
    parseRupiah(price) {
      if (price == null) {
        return "";
      } else {
        return (
          "Rp " +
          price.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.")
        );
      }
    },
  },
  created() {
    this.GET_LIST_HISTORY();
    this.getListHistory;
  },
  mounted() {
    // console.log(this.getListHistory);
    this.historyDetail = this.getListHistory;
  },
};
</script>
